
import styled from "styled-components"
import Btn from "../shared/button/Btn"
import { useDispatch } from "react-redux"
import { showNestedModal } from "../../features/modal/modalSlice"
import { setOperationRoute } from "../../features/shipmentOperation/shipmentOperationSlice"


const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: auto;

`
const RouteItem = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  min-height: 150px;
  height: auto;

  .line-side {
    width: 20px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: ${({ isLast }) => (isLast ? "flex-end" : "flex-start")};
    flex-direction: column;
  }

  .circle {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: var(--color-main);
  }

  .line {
    border: 1px solid var(--color-main);
    height: calc(50% - 10px);
  }

  .route-item-data-container {
    position: relative;
    padding: 20px;
    width: calc(100% - 60px);
    background-color: ${({ theme }) => theme.mainBgColor};
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid;
    border-color:transparent;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: -10px;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-right: 10px solid ${({ isActiveRoute, theme }) => isActiveRoute ? "var(--color-main)" : theme.mainBgColor};

    }

    &:hover {
      background-color: ${({ theme }) => theme.secondaryBgColor};
        border-color:   var(--color-main);

      &::before {
        border-right-color: var(--color-main);

      }
    }

    .left-side {
      display: flex;
      flex-direction: column;
      gap: 7px;

      .route-item-title {
        font-size: 15px;
        font-weight: var(--font-weight-lg);
      }

      .route-item-location {
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
      }

      .completed-by{
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        color: var(--color-main);

      }

      .operation-user{
        display: flex;
        flex-wrap: wrap;
        gap: 4px 10px;
        font-size: 12px;
        line-height: 1.4;
      }

      .operation-user strong{
        font-weight: var(--font-weight-lg);
      }
    }

    .action-container{
        display: flex;
        flex-direction: column;
        gap: 15px;
    }
  }
`;


const alphabetList = ["A", "B", "C", "D", "E", "F", "G","H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]

const formatUtcDate = (value) => {
  if (!value) return null
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return null
  return date.toLocaleString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
}

const getOperationUser = (routeItem, prefix) => [
  routeItem?.[`${prefix}ByUserName`],
  routeItem?.[`${prefix}ByUserPhoneNumber`],
  routeItem?.[`${prefix}ByCompany`],
].filter(Boolean).join(" · ")


const RouteLine = ({route}) => {

    const dispatch = useDispatch()


  return (
    <Container>
      {
        route.map((routeItem, i) => {
          const startedBy = getOperationUser(routeItem, "started")
          const updatedBy = getOperationUser(routeItem, "updated")
          const startDate = formatUtcDate(routeItem?.routePointStartDate)
          const endDate = formatUtcDate(routeItem?.routePointEndDate)

          return (
            <RouteItem key={routeItem?.id ?? `${routeItem?.order}-${i}`} isLast={route.length !== i+1}>
                <div className="line-side">
                    {
                        i !== 0 &&
                        <div className="line"></div>
                    }
                    <div className="circle"></div>
                    {
                        route.length !== i+1 &&
                        <div className="line"></div>
                    }
                </div>
                <div className="route-item-data-container">
                    <div className="left-side">
                        <h3 className="route-item-title">{alphabetList[i]}. {routeItem.loadOrUnload === 0 ? "Yükleme" : "Boşaltma"}</h3>
                        <div className="route-item-location">{routeItem.location}</div>

                        {(startedBy || startDate) && (
                          <div className="operation-user">
                            {startedBy && <span><strong>Başlatan:</strong> {startedBy}</span>}
                            {startDate && <span><strong>Başlangıç:</strong> {startDate}</span>}
                          </div>
                        )}

                        {(updatedBy || endDate) && (
                          <div className="operation-user completed-by">
                            {updatedBy && <span><strong>Bitiren:</strong> {updatedBy}</span>}
                            {endDate && <span><strong>Bitiş:</strong> {endDate}</span>}
                          </div>
                        )}

                        {/* {
                            activeRoute?.id === routeItem?.id &&
                            <div>{routeItem.stateOfRoutePoint === 0 ? "Başlanmadı" : routeItem.stateOfRoutePoint === 1 ? "Başlandı" : "Bitirildi"}</div>
                        } */}
                    </div>
                    <Btn handleClick={() => {dispatch(setOperationRoute(routeItem)); dispatch(showNestedModal("shipmentRouteOperation")) }} width={"180px"} bgColor="#333" borderColor="transparent" color="#fff" padding="10px">{routeItem.stateOfRoutePoint === 0 ? (routeItem?.loadOrUnload === 0 ? "Yüklemeye Başla" : "Boşaltmaya Başla") : routeItem.stateOfRoutePoint === 1 ? (routeItem?.loadOrUnload === 0 ? "Yüklemeyi Tamamla" : "Boşaltmayı Tamamla") : "Tamamlandı"}</Btn>
                    {/* {
                        activeRoute?.id === routeItem?.id &&
                        <div className="action-container">
                            {
                                routeItem.stateOfRoutePoint > 0 &&
                                <InputTextarea data={""} setData={(e) => e.target.value} labelText={"Açıklama"} inputWidth={"280px"} name={"asdas"}/>
                            }
                            <Btn handleClick={() => handleClick(routeItem)} width={"180px"} bgColor="#333" borderColor="transparent" color="#fff" padding="10px">{routeItem.stateOfRoutePoint === 0 ? (routeItem?.loadOrUnload === 0 ? "Yüklemeye Başla" : "Boşaltmaya Başla") : routeItem.stateOfRoutePoint === 1 ? (routeItem?.loadOrUnload === 0 ? "Yüklemeyi Tamamla" : "Boşaltmayı Tamamla") : "Tamamlandı"}</Btn>
                        </div>
                    } */}
                </div>
            </RouteItem>
          )
        })
      }
    </Container>
  )
}

export default RouteLine
